import { useTranslation } from 'react-i18next';
import { useInviteeChanged } from './createHearingInvitations/inviteeChangedPanel/utility/useInviteeChanged';
import { Modal, PrimaryButton, Text } from 'office-ui-fabric-react';

const InviteeChangedPanel = () => {
  const { t: translator } = useTranslation();
  const {
    metaData,
    isPopupOpen,
    setIsPopupOpen,
    onConfirm,
  } = useInviteeChanged();

  return (
    <div className="global-message">
      <Modal isOpen={isPopupOpen} onDismiss={setIsPopupOpen}>
        <div className="modal-outer">
          <div className="modal-outer-content">
            <div className="pb-1">
              <Text className="font-bold">
                {translator(
                  'pages.createHearing.createHearingInvitations.inviteeChangedPanel.newInvitees',
                )}
              </Text>
              {': '}
              <Text>{metaData.newInvitees}</Text>
            </div>
            <div className="pb-1">
              <Text className="font-bold">
                {translator(
                  'pages.createHearing.createHearingInvitations.inviteeChangedPanel.deletedInvitees',
                )}
              </Text>
              {': '}
              <Text>{metaData.deletedInvitees}</Text>
            </div>
            <div className="pb-1">
              <Text className="font-bold">
                {translator(
                  'pages.createHearing.createHearingInvitations.inviteeChangedPanel.existingInvitees',
                )}
              </Text>
              {': '}
              <Text>{metaData.existingInvitees}</Text>
            </div>
            <div>
              <Text className="font-bold">
                {translator(
                  'pages.createHearing.createHearingInvitations.inviteeChangedPanel.inviteesNotDeleted',
                )}
              </Text>
              {': '}
              <Text>{metaData.inviteesNotDeleted}</Text>
            </div>
          </div>
          <div className="global-message-modal-button-bar">
            <PrimaryButton
              text={translator('global.confirm')}
              onClick={onConfirm}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export { InviteeChangedPanel };
